import React from 'react';
import { Lock, Star, Smartphone, Clock, ShieldCheck, MessageSquare } from 'lucide-react';
export function SalesHero() {
  return <section className="relative flex items-center justify-center bg-[#faf6f1] text-[#3d2b1f] overflow-hidden pt-6 pb-10 px-5 md:px-6 md:pt-12 md:pb-16" data-id="element-229">
      {/* Soft Botanical/Organic Blobs — hidden on mobile for performance */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-40 pointer-events-none hidden md:block" data-id="element-230">
        <div className="absolute top-[-10%] left-[-5%] w-[40%] h-[50%] rounded-full bg-[#e0bfb4] blur-[100px]" data-id="element-231" />
        <div className="absolute bottom-[-10%] right-[-5%] w-[40%] h-[50%] rounded-full bg-[#d4b896] blur-[100px]" data-id="element-232" />
      </div>

      <div className="max-w-6xl mx-auto w-full relative z-10" data-id="element-233">
        {/* Text Content — always visible, no animation dependency */}
        <div className="text-center w-full max-w-3xl mx-auto" data-id="element-234">
          <h1 className="mb-4 md:mb-5 text-[#3d2b1f]" data-id="element-235">
            <span className="block text-[1.6rem] sm:text-4xl md:text-5xl lg:text-[3.4rem] font-extrabold leading-[1.15] mb-2 md:mb-3" data-id="element-236">
              Llevas años vendiéndole tu cuerpo al trabajo físico.
            </span>
            <span className="block text-[1.25rem] sm:text-3xl md:text-4xl lg:text-[2.6rem] font-bold leading-[1.2] text-[#b8956a]" data-id="element-237">
              Cada día que esperas es un cliente latino que le paga a otra
              persona.
            </span>
          </h1>

          {/* Mini Testimonials — right below headline */}
          <div className="max-w-lg mx-auto mb-3 md:mb-4 bg-white/80 md:bg-white/70 md:backdrop-blur rounded-xl p-3 md:p-4 border border-[#e0bfb4]/40" data-id="element-238">
            <div className="flex items-start gap-3" data-id="element-239">
              <img src="https://cdn.magicpatterns.com/uploads/bTo6UHRDaSPqpujWDT7gvw/pov_3.png" alt="Laura P. — testimonio" className="w-11 h-11 rounded-full object-cover border-2 border-[#b8956a]/30 flex-shrink-0" width={44} height={44} loading="eager" decoding="async" data-id="element-240" />
              <div className="text-left" data-id="element-241">
                <p className="text-sm text-[#3d2b1f] leading-snug" data-id="element-242">
                  <span className="italic" data-id="element-243">
                    "Llegué a este país sin contactos, sin inglés y con miedo de
                    no poder salir adelante. En 18 días con este método hice mis
                    primeros $520 gestionando redes para negocios latinos en mi
                    ciudad."
                  </span>
                </p>
                <div className="flex items-center gap-1.5 mt-1" data-id="element-244">
                  <div className="flex gap-0.5" data-id="element-245">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 text-[#b8956a] fill-current" data-id="element-246" />)}
                  </div>
                  <span className="text-xs text-[#9a8b7a] font-medium" data-id="element-247">
                    — Laura P., Houston TX · $520 en 18 días
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="max-w-lg mx-auto mb-5 md:mb-6 bg-white/80 md:bg-white/70 md:backdrop-blur rounded-xl p-3 md:p-4 border border-[#e0bfb4]/40" data-id="element-248">
            <div className="flex items-start gap-3" data-id="element-249">
              <img src="https://cdn.magicpatterns.com/uploads/gGrazWDqrpDg6mm4QRQqFA/mujer_latina_2.png" alt="María G. — testimonio" className="w-11 h-11 rounded-full object-cover border-2 border-[#b8956a]/30 flex-shrink-0" width={44} height={44} loading="eager" decoding="async" data-id="element-250" />
              <div className="text-left" data-id="element-251">
                <p className="text-sm text-[#3d2b1f] leading-snug" data-id="element-252">
                  <span className="italic" data-id="element-253">
                    "Lo compré un domingo y el lunes ya tenía mi primer cliente
                    por WhatsApp. En menos de 2 semanas ya había hecho $340 —
                    sin inglés, sin salir de casa."
                  </span>
                </p>
                <div className="flex items-center gap-1.5 mt-1" data-id="element-254">
                  <div className="flex gap-0.5" data-id="element-255">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 text-[#b8956a] fill-current" data-id="element-256" />)}
                  </div>
                  <span className="text-xs text-[#9a8b7a] font-medium" data-id="element-257">
                    — María G., Miami FL · Primer cliente en 24 horas
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* List - "Cuando abres el mapa vas a encontrar:" */}
          <div className="max-w-2xl mx-auto mb-3 md:mb-4" data-id="element-258">
            <p className="text-base md:text-xl text-[#6b5744] font-medium mb-3 text-center" data-id="element-259">
              Cuando abres el mapa vas a encontrar:
            </p>
            <ul className="space-y-2 text-left mx-auto w-fit sm:text-left" data-id="element-260">
              {['Los 5 roles que puedes ofrecer hoy', 'Dónde buscar exactamente esos negocios', 'Qué decirles palabra por palabra', 'Las plataformas donde están pagando ahora', 'Las plantillas listas para copiar y pegar'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm md:text-base text-[#3d2b1f] font-medium" data-id="element-261">
                  <span className="text-[#7a9a6b] font-bold mt-0.5 flex-shrink-0" data-id="element-262">
                    ✓
                  </span>
                  <span data-id="element-263">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Product Mockup */}
          <div className="mb-4 max-w-xs sm:max-w-sm mx-auto" data-id="element-264">
            <div className="relative" data-id="element-265">
              <div className="absolute inset-0 bg-[#c9977e] rounded-3xl hidden md:block blur-3xl opacity-10 transform rotate-3" data-id="element-266"></div>
              <img src="https://cdn.magicpatterns.com/uploads/wppacRyZC2Ww6zkTNvLKh7/FREELANCE_NEW_COVER.png" alt="Freelance desde Cero (Sin Inglés) - Guía Digital" className="relative w-full h-auto rounded-2xl shadow-lg md:shadow-2xl md:transform md:transition-transform md:hover:scale-[1.02] md:duration-500 border border-[#e0bfb4]/30" width={384} height={384} fetchPriority="high" decoding="async" data-id="element-267" />
            </div>
          </div>

          <p className="text-center md:text-base font-medium italic mb-5 md:mb-6 text-[20px] text-[#3D2B1F]" data-id="element-268">
            Todo esto se lee en 2 horas desde tu celular. Sin teoría. Solo
            pasos.
          </p>

          {/* Value Anchor + Guarantee + CTA */}
          <div className="flex flex-col items-center gap-2 mb-6 md:mb-8" data-id="element-269">
            <div className="flex items-center gap-2 mb-1" data-id="element-270">
              <span className="text-[#9a8b7a] line-through text-sm font-medium" data-id="element-271">
                Valor $197
              </span>
              <span className="text-[#3d2b1f] font-extrabold text-lg md:text-xl" data-id="element-272">
                Hoy $14 USD
              </span>
            </div>
            <div className="flex items-center gap-2 text-[11px] md:text-sm text-[#7a9a6b] font-semibold mb-1" data-id="element-273">
              <ShieldCheck className="w-3.5 h-3.5 flex-shrink-0" data-id="element-274" />
              <span data-id="element-275">
                Garantía 7 días — si no te sirve, te devuelvo tu dinero
              </span>
            </div>
            <a href="#offer" className="w-full sm:w-auto px-6 md:px-8 py-3.5 md:py-4 bg-[#b8956a] hover:bg-[#c9a87a] text-[#3d2b1f] font-bold text-base md:text-lg rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 group" data-id="element-276">
              Sí, quiero conseguir mi primer cliente — $14 USD →
            </a>
            <div className="flex items-center gap-2 text-[11px] md:text-sm text-[#6b5744] font-medium opacity-80" data-id="element-277">
              <Lock className="w-3.5 h-3.5 flex-shrink-0" data-id="element-278" />
              <span data-id="element-279">Acceso inmediato · Pago único · 100% en español</span>
            </div>
            <p className="text-xs md:text-sm font-bold text-[#c47a6a] mt-1" data-id="element-280">
              ⚠️ Precio de $14 disponible solo esta semana
            </p>
          </div>

          {/* Credibility Band */}
          <div className="w-full max-w-md mx-auto bg-white/70 md:backdrop-blur rounded-2xl p-3 md:p-4" data-id="element-281">
            <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-282">
              <div className="flex items-center gap-2" data-id="element-283">
                <div className="bg-[#b8956a]/10 p-1.5 rounded-full flex-shrink-0" data-id="element-284">
                  <Star className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#b8956a]" data-id="element-285" />
                </div>
                <span className="md:text-xs font-medium text-[14px] text-[#3D2B1F]" data-id="element-286">
                  +1,200 mujeres latinas ya tienen el mapa
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-287">
                <div className="bg-[#7a9a6b]/10 p-1.5 rounded-full flex-shrink-0" data-id="element-288">
                  <Smartphone className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#7a9a6b]" data-id="element-289" />
                </div>
                <span className="md:text-xs font-medium text-[14px] text-[#3D2B1F]" data-id="element-290">
                  Funciona desde tu celular
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-291">
                <div className="bg-[#c47a6a]/10 p-1.5 rounded-full flex-shrink-0" data-id="element-292">
                  <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#c47a6a]" data-id="element-293" />
                </div>
                <span className="md:text-xs font-medium text-[14px] text-[#3D2B1F]" data-id="element-294">
                  Resultados en 7 días o menos
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-295">
                <div className="bg-[#b8956a]/10 p-1.5 rounded-full flex-shrink-0" data-id="element-296">
                  <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#b8956a]" data-id="element-297" />
                </div>
                <span className="md:text-xs font-medium text-[14px] text-[#3D2B1F]" data-id="element-298">
                  Garantía 7 días sin preguntas
                </span>
              </div>
              <div className="flex items-center gap-2 col-span-2 justify-center" data-id="element-299">
                <div className="bg-[#7a9a6b]/10 p-1.5 rounded-full flex-shrink-0" data-id="element-300">
                  <MessageSquare className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#7a9a6b]" data-id="element-301" />
                </div>
                <span className="text-[10px] md:text-xs font-medium text-[#6b5744] leading-tight" data-id="element-302">
                  100% en español sin una palabra en inglés
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}